export enum EMobileDeviceType {
  iOS = 'ios',
  Android = 'android',
  Unknown = 'unknown',
}
